import axios from "axios"
import { toast } from "react-toastify"

export const USERNAME = "admin@rysun.com"
export const PASSWORD = "admin@1234"
export const AI_CHATBOT_NAME = "AI Chatbot"
export const FEATURE_FLAG_KEY = {
    history: "comp_history",
    like: "fun_like",
    Dislike: "fun_dislike",
    share: "fun_share",
    download: "fun_download",
    copy: "fun_copy",
    textSpeech: "fun_text_to_speech",
    changepassword: "comp_change_password",
    voiceSearch: "fun_speak",
    sourceInfo: "source_info",
    showNotification: "comp_notification_bar",
    dashboard: "page_dashboard",
    flagSetting: "flag_setting_page",
    model: "model",
    inventoryForecast: "inventory_forecast",
    salesForecast: "sales_forecast",
    languageTranslation: "language_translation",
}
export const SVG_NAME: any = {
    aggregative_dashboard: "fa-gauge-high",
    upload_document: "fa-upload",
    user_management: "fa-user-gear",
    role_management: "fa-people-line",
    group_management: "fa-users-gear",
    announcements: "fa-bell",
    permission_management: "fa-user-lock",
    flag_settings: "fa-gear",
    doc_approval: "fa-file-circle-check",
    doc_process: "fa-arrow-up-from-bracket",
    bot: "fa-robot",
    voice: "fa-microphone",
    q_a: "fa-file-circle-question",
    configuration: "fa-user-gear",
    scrapper: "fa-database",
    black_listed_word: "fa-file-lines",
    bot_configuration: "fa-user-gear",
    sftp: "fa-regular fa-file",
    similar_images: "fa-regular fa-image",
    image_extender: "fa-regular fa-image",
    generate_instance: "fa-regular fa-image",
    smart_background: "fa-regular fa-image",
    inventory_forecast: "fa-regular fa-image"
}

export const radioOptions: any = [
    "Q&A",
    "Entities",
    "Summarization",
    "Classification",
];

export const PERMISSION_DENIED_MESSAGE = "You don't have access to it"

export const PERMISSION_KEY = {
    dashboard: "aggregative_dashboard",
    role: "role_management",
    group: "group_management",
    user: "user_management",
    uploadDoc: "doc_process",
    announcements: "announcements",
    docApproval: "doc_approval",
    flagSettings: "flag_settings",
    permissions: "permission_management",
    voice: "voice",
    bot: "bot",
    q_a: "q_a",
    black_listed_word: "black_listed_word",
    bot_configuration: "bot_configuration",
    scrapper: "scrapper",
    configuration: "configuration",
    sftp: "sftp",
    lens: "lens",
    imageExtender: "image_extender",
    similarImages: "similar_images",
    smartBackground: "smart_background",
    generateInstance: "generate_instance",
    inventoryForecast: "inventory_forecast",
    inventoryForecastConfiguration: "inventory_forecast_configuration",
    salesForecast: "sales_forecast",
    dynamicPricing: "dynamic_pricing",
    imageComparison: "image_comparison",
    articleGeneration: "article_generation",
    emailGeneration: "email_generation",
    ideaGeneration: "idea_generation",
    postGeneration: "post_generation",
    productDesGeneration: "product_des_generation",
    sentimentAnalysis: "generate_sentiment_analysis",
    conversationHistory: "conversation_history",
}

export const GUESTUSER_3 = "guest3@rysun.com"
export const GUEST_PASSWORD = "Guest@123"
export const LOGOUT_TIME_MIN = 30
export const env = localStorage.getItem("clientName");
export const feilds = [
    { key: 'keycloak_credentials.client_id', type: 'text', label: "ID(Keycloak Configuration)", toolTipInfo: "  Client ID acts as a unique identifier for client accessing resources within the Keycloak authentication system.", category: "General", field1: "key1", field2: "key2" },
    { key: 'keycloak_credentials.client_secret', type: 'text', label: "Secret(Keycloak Configuration)", toolTipInfo: "Client secret in Keycloak is a confidential key used for secure communication between client and the authentication server.", category: "General", field1: "key1", field2: "key2" },
    { key: 'keycloak_credentials.realm_name', type: 'text', label: "Realm(Keycloak Configuration)", toolTipInfo: "Realm acts as a container for users, roles, and groups, defining security boundaries within the system.", category: "General", field1: "key1", field2: "key2" },
    { key: 'keycloak_credentials.base_url', type: 'text', label: "Base URL(Keycloak Configuration)", toolTipInfo: "Base URL for accessing Keycloak's authentication and authorization services.", category: "General", field1: "key1", field2: "key2" },
    { key: 'log_source', type: 'dropdown', label: "Log Source", toolTipInfo: "The source from which the logs are being collected.", category: "General", field1: "key1", field2: "key2" },
    { key: 'mongodb_credentials.connection_name', type: 'text', label: "Connection Name(MongoDB Configuration)", tempKey: "MongoDB", toolTipInfo: "Port defines the connection point for logging data storage.", category: "General", field1: "key1", field2: "key2" },
    { key: 'mongodb_credentials.host_port', type: 'text', label: "Port Number(MongoDB Configuration)", tempKey: "MongoDB", toolTipInfo: "Host Url stores the location information of the Logger service.", category: "General", field1: "key1", field2: "key2" },
    { key: 'mongodb_credentials.user_name', type: 'text', label: "Username(MongoDB Configuration)", tempKey: "MongoDB", toolTipInfo: "It specifies the logger's username for authentication.", category: "General", field1: "key1", field2: "key2" },
    { key: 'mongodb_credentials.password', type: 'password', label: "Password(MongoDB Configuration)", tempKey: "MongoDB", toolTipInfo: "It specifies Logger's password for secure access.", category: "General", field1: "key1", field2: "key2" },
    { key: 'mongodb_credentials.db_name', type: 'text', label: "DB_Name(MongoDB Configuration)", tempKey: "MongoDB", toolTipInfo: "It specifies the database name for Logger.", category: "General", field1: "key1", field2: "key2" },
    { key: 'postgres_credentials.host_port', type: 'text', label: "Port Number(PostgressDB Configuration)", toolTipInfo: "Host Url stores the location information of the Logger service.", category: "General", field1: "key1", field2: "key2" },
    { key: 'postgres_credentials.user_name', type: 'text', label: "Username(PostgressDB Configuration)", toolTipInfo: "It specifies the logger's username for authentication.", category: "General", field1: "key1", field2: "key2" },
    { key: 'postgres_credentials.password', type: 'password', label: "Password(PostgressDB Configuration)", toolTipInfo: "It specifies Logger's password for secure access.", category: "General", field1: "key1", field2: "key2" },
    { key: 'postgres_credentials.db_name', type: 'text', label: "DB_Name(PostgressDB Configuration)", toolTipInfo: "It specifies the database name for Logger.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_ml_api.base_url_ron', type: 'text', label: "Base Url Ron", toolTipInfo: "The base URL where authentication requests are directed.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_ml_api.base_url_gpt', type: 'text', label: "Base Url Gpt", toolTipInfo: "The base URL where authentication requests are directed.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_ml_api.base_url_file_processing', type: 'text', label: "Base Url File Processing", toolTipInfo: "It used to transmit data and receive predictions, enabling remote access and interaction with machine learning models.", category: "General", field1: "key1", field2: "key2" },
    { key: 'file_size', type: 'number', label: "Max file size", toolTipInfo: "It's used to restrict users to upload files within a specified size limit. ", category: "General", field1: "key1", field2: "key2" },
    { key: 'email_configuration.smtp_server', type: 'text', label: "Server Name(SMTP Details)", toolTipInfo: "Email Config is used to efficiently configure your email settings for streamlined communication and connectivity. SMTP servers handle outgoing email delivery within an email configuration.", category: "General", field1: "key1", field2: "key2" },
    { key: 'email_configuration.smtp_port', type: 'number', label: "Port Number(SMTP Details)", toolTipInfo: "SMTP port for email configuration ensures efficient outgoing mail delivery.", category: "General", field1: "key1", field2: "key2" },
    { key: 'email_configuration.smtp_username', type: 'text', label: "Username(SMTP Details)", toolTipInfo: "SMTP username for Email Configurations facilitates secure access and sending of emails.", category: "General", field1: "key1", field2: "key2" },
    { key: 'email_configuration.smtp_password', type: 'password', label: "Password(SMTP Details)", toolTipInfo: "SMTP password for email configuration ensures secure access for outgoing messages.", category: "General", field1: "key1", field2: "key2" },
]

export const formFields = [
    { field: 'logos_urls.logo_home_page', header: 'Logo for Login/Registration', type: 'file_upload', category: "General", toolTipInfo: "To update the logo image on the Login/Registration page.", field1: "key1", field2: "key2" },
    { field: 'logos_urls.logo_side_img', header: 'Logo for Side Menu', type: 'file_upload', category: "General", toolTipInfo: "To update the logo image on the Side Menu.", field1: "key1", field2: "key2" },
    { field: 'client_name', header: 'ENV', type: 'input', category: "General", toolTipInfo: "Name of Client.", field1: "key1", field2: "key2" },
    // { field: 'default_label', header: 'Initial Text', type: 'input_text', category: "General", toolTipInfo: "To add the introductory text onto the Q&A page", field1: "key1", field2: "key2" },
    { field: 'default_questions', header: 'Questions', type: 'input', category: "General", toolTipInfo: "To set default questions in Qmate.", field1: "key1", field2: "key2" },
];


export const Backendfeilds = [
    // { key: 'lama_model_conf.n_gpu_layers', type: 'number', label: "N-GPU Layers", toolTipInfo: "It offers parallel processing, enhancing speed and efficiency in deep learning models.", category: "General", field1: "key1", field2: "key2" },
    // { key: 'lama_model_conf.n_batch', type: 'number', label: "N-Batch", toolTipInfo: "It facilitates data processing by dividing it into manageable chunks, enhancing efficiency and model training.", category: "General", field1: "key1", field2: "key2" },
    { key: 'lama_model_conf.max_token', type: 'dropdown', label: "Max Tokens", toolTipInfo: "It sets the maximum number of tokens generated during text processing, managing model efficiency.", category: "General", field1: "key1", field2: "key2" },
    { key: 'lama_model_conf.temperature', type: 'slider', label: "Temperature", toolTipInfo: "It adjusts the model's randomness, controlling the diversity of generated outputs during sampling processes.", category: "General", field1: "key1", field2: "key2" },
    // { key: '', type: 'slider', label: "", toolTipInfo: "It adjusts the model's randomness, controlling the diversity of generated outputs during sampling processes.", category: "General", field1: "key1", field2: "key2" },
    // { key: 'lama_model_conf.n_ctx', type: 'slider', label: "N-Ctx", toolTipInfo: "It enhances model performance by capturing and leveraging local patterns and relationships in data.", category: "General", field1: "key1", field2: "key2" },
    { key: 'lama_model_conf.streaming', type: 'dropdown', label: "Streaming", toolTipInfo: "It sets the maximum number of tokens generated during text processing, managing model efficiency.", category: "General", field1: "key1", field2: "key2" },
    { key: 'RON_lama_system_prompt.default_system_prompt', type: 'text_area', label: "System Prompt", toolTipInfo: "It is used to guide the model's behavior by providing contextual instructions, enhancing output relevance.", category: "General", field1: "key1", field2: "key2" },
    { key: 'RON_lama_system_prompt.prompt_document_training', type: 'text_area', label: "Document Training System Prompt", toolTipInfo: "It enhances model performance by guiding training with specific document-based prompts.", category: "General", field1: "key1", field2: "key2" },
    { key: 'RON_lama_system_prompt.ner_prompt', type: 'text_area', label: "NER", toolTipInfo: "It is used to identify and categorize entities within text, aiding in information extraction and analysis.", category: "General", field1: "key1", field2: "key2" },
    { key: 'RON_lama_system_prompt.prompttemplatetextsummerization', type: 'text_area', label: "Summarization", toolTipInfo: "It refines output by guiding models to focus on key content, aiding concise and accurate summaries.", category: "General", field1: "key1", field2: "key2" },
    { key: 'RON_lama_system_prompt.prompttemplateclassification', type: 'text_area', label: "Classification", toolTipInfo: "It is used to optimize model behavior by guiding it to categorize and interpret data accurately.", category: "General", field1: "key1", field2: "key2" },
    { key: 'pdf_documents.chunk_size', type: 'dropdown', label: "Chunk Size(PDF Processing)", toolTipInfo: "Chunk size refers to the maximum number of characters that a single chunk can contain.", category: "General", field1: "key1", field2: "key2" },
    { key: 'pdf_documents.chunk_overlap', type: 'dropdown', label: "Chunk Overlap(PDF Processing)", toolTipInfo: "Chunk overlap refers to the number of characters that should overlap between two adjacent chunks.", category: "General", field1: "key1", field2: "key2" },
    { key: 'lama_model_name.model_name_or_path', type: 'text', label: "Model Name/Path", toolTipInfo: " Represents the current model name and the path used to retrieve and load the model.", category: "General", field1: "key1", field2: "key2" },
    // { key: 'temp_vector_db_path', type: 'text', label: "Temp Vector DB Path", toolTipInfo: "It optimizes data extraction and analysis from documents for enhanced automation and insights", category: "General", field1: "key1", field2: "key2" },
    // { key: 'lama_model_name.model_basename', type: 'text', label: "Model BaseName", toolTipInfo: "It optimizes data extraction and analysis from documents for enhanced automation and insights", category: "General", field1: "key1", field2: "key2" },
    { key: 'embedding_model_name.embedding_model_name', type: 'text', label: "Embedding model name", toolTipInfo: "Embedding models are algorithms trained to encapsulate information into dense representations within a multi-dimensional space.", category: "General", field1: "key1", field2: "key2" },
    { key: 'faiss_vactor_db.ron_main_vector_db_directory', type: 'text', label: "Vector DB Path", toolTipInfo: "Specifies the stored path of the vector database, a specialized database designed to store, index, and query data in vectorized format.", category: "General", field1: "key1", field2: "key2" },
    { key: 'faiss_vactor_db.user_temp_folder', type: 'text', label: "Temp Folder", toolTipInfo: "It optimizes data extraction and analysis from documents for enhanced automation and insights.", category: "General", field1: "key1", field2: "key2" },
    // { key: 'faiss_vactor_db.source_info_threshold', type: 'slider', label: "Source Info Threshold", toolTipInfo: "The threshold value is used to obtain accurate source information.", category: "General", field1: "key1", field2: "key2" },
    { key: 'actual_pdf.actual_pdf_base_url', type: 'text', label: "Data source path", toolTipInfo: "Specifies the location of the data source for retrieval and processing.", category: "General", field1: "key1", field2: "key2" },
    { key: 'TGI_llama_inference_url.inference_server_url_local', type: 'text', label: "Inference Server URL", toolTipInfo: "It optimizes data extraction and analysis from documents for enhanced automation and insights.", category: "General", field1: "key1", field2: "key2" },
    { key: 'Metadata.version', type: 'number', label: "MetaData Version", toolTipInfo: "Specifies the version of metadata being used for this configuration.", category: "General", field1: "key1", field2: "key2" },
]
export const Generationfeilds = [
    { key: 'generation_param.inference_server_url', type: 'text', label: "Inference Server URL", toolTipInfo: "Processes input prompts and queries using a model to generate responses based on request parameters.", category: "General", field1: "key1", field2: "key2" },
    { key: 'generation_param.max_new_tokens', type: 'dropdown', label: "Max Tokens", toolTipInfo: "It sets the maximum number of tokens generated during text processing, managing model efficiency.", category: "General", field1: "key1", field2: "key2" },
    { key: 'generation_param.temperature', type: 'slider', label: "Temperature", toolTipInfo: "It adjusts the model's randomness, controlling the diversity of generated outputs during sampling processes.", category: "General", field1: "key1", field2: "key2" },
    { key: 'generation_param.default_email_template', type: 'text_area', label: "Email Prompt", toolTipInfo: "It is set of instructions given by prompting which helps in generating email based on user inputs.", category: "General", field1: "key1", field2: "key2" },
    { key: 'generation_param.default_post_template', type: 'text_area', label: "Post Prompt", toolTipInfo: " It is set of instructions given by prompting which helps in generating post based on user inputs.", category: "General", field1: "key1", field2: "key2" },
    { key: 'generation_param.default_product_template', type: 'text_area', label: "Product Prompt", toolTipInfo: " It is set of instructions given by prompting which helps in generating product description based on user inputs.", category: "General", field1: "key1", field2: "key2" },
    { key: 'generation_param.default_regenerate_product_template', type: 'text_area', label: "Regenerate Product Prompt", toolTipInfo: "It is set of instructions given by prompting which helps in regenerating product description based on user inputs.", category: "General", field1: "key1", field2: "key2" },
    { key: 'generation_param.default_article_template', type: 'text_area', label: "Article Prompt", toolTipInfo: "It is set of instructions given by prompting which helps in generating article based on user inputs.", category: "General", field1: "key1", field2: "key2" },
    { key: 'generation_param.default_idea_template', type: 'text_area', label: "Idea Prompt", toolTipInfo: " It is set of instructions given by prompting which helps in generating ideas based on user inputs.", category: "General", field1: "key1", field2: "key2" },
]

export const ButterPiefeilds = [
    { key: 'butter_pie_configuration.content_strategy', type: 'text_area', label: "Content Strategy & Branding", toolTipInfo: "Processes input prompts and queries using a model to generate responses based on request parameters.", category: "General", field1: "key1", field2: "key2" },
    { key: 'butter_pie_configuration.content_production', type: 'text_area', label: "Content Production & Editing", toolTipInfo: "It sets the maximum number of tokens generated during text processing, managing model efficiency.", category: "General", field1: "key1", field2: "key2" },
    { key: 'butter_pie_configuration.audience_growth', type: 'text_area', label: "Audience Growth & Engagement", toolTipInfo: "It adjusts the model's randomness, controlling the diversity of generated outputs during sampling processes.", category: "General", field1: "key1", field2: "key2" },
    { key: 'butter_pie_configuration.monetization', type: 'text_area', label: "Monetization & Business Strategy", toolTipInfo: "It is set of instructions given by prompting which helps in generating email based on user inputs.", category: "General", field1: "key1", field2: "key2" },
    { key: 'butter_pie_configuration.marketing_seo', type: 'text_area', label: "Marketing & SEO", toolTipInfo: " It is set of instructions given by prompting which helps in generating post based on user inputs.", category: "General", field1: "key1", field2: "key2" },
    { key: 'butter_pie_configuration.legal_ethical', type: 'text_area', label: "Legal & Ethical Considerations", toolTipInfo: " It is set of instructions given by prompting which helps in generating product description based on user inputs.", category: "General", field1: "key1", field2: "key2" },
    { key: 'butter_pie_configuration.mindset_productivity', type: 'text_area', label: "Mindset & Productivity", toolTipInfo: "It is set of instructions given by prompting which helps in regenerating product description based on user inputs.", category: "General", field1: "key1", field2: "key2" },
    { key: 'butter_pie_configuration.networking', type: 'text_area', label: "Networking & Collaboration", toolTipInfo: "It is set of instructions given by prompting which helps in generating article based on user inputs.", category: "General", field1: "key1", field2: "key2" },
    { key: 'butter_pie_configuration.general_prompt', type: 'text_area', label: "General Prompt", toolTipInfo: " It is set of instructions given by prompting which helps in generating ideas based on user inputs.", category: "General", field1: "key1", field2: "key2" },
    { key: 'butter_pie_configuration.api_key', type: 'text', label: "Api Key", toolTipInfo: "Processes input prompts and queries using a model to generate responses based on request parameters.", category: "General", field1: "key1", field2: "key2" },
]



export const ChatBotParamsFeilds = [
    { key: 'ai_chatbot.temperature', type: 'slider', label: "Temperature", toolTipInfo: "It adjusts the model's randomness, controlling the diversity of generated outputs during sampling processes.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_chatbot.max_token', type: 'dropdown', label: "Max Token", toolTipInfo: "It sets the maximum number of tokens generated during text processing, managing model efficiency.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_chatbot.log_url', type: 'text', label: "Log URL", toolTipInfo: "URL to access detailed logs related to the application's processing.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_chatbot.source_name', type: 'text', label: "Source Name", toolTipInfo: "Name of the source system generating the data.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_chatbot.max_pdf_size', type: 'dropdown', label: "Max PDF Size", toolTipInfo: "Maximum allowable size (MB) for uploaded PDF files.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_chatbot.max_zip_size', type: 'dropdown', label: "Max ZIP Size", toolTipInfo: "Maximum allowable size (MB) for uploaded ZIP files.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_chatbot.primary_column', type: 'text', label: "Primary Column", toolTipInfo: "The main identifier column used to uniquely distinguish each record (e.g., 'Product ID') for style recommendation.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_chatbot.product_details', type: 'text', label: "Product Details", toolTipInfo: "Name of the column containing detailed information about the product for style recommendation.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_chatbot.main_category', type: 'text', label: "Main Category", toolTipInfo: "Column representing the primary category classification for the data for style recommendation.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_chatbot.sub_category', type: 'text', label: "Sub Category", toolTipInfo: "Column representing the sub-category classification for the data for style recommendation.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_chatbot.category_style_idea', type: 'text', label: "Category Style Idea", toolTipInfo: "List of category style inspirations relevant for classification.", category: "General", field1: "key1", field2: "key2" },
    { key: 'ai_chatbot.bundling_on_column_name', type: 'text', label: "Bundling on Column Name", toolTipInfo: "Column name used for bundling user history data.", category: "General", field1: "key1", field2: "key2" },
    // { key: 'ai_chatbot.system_prompt', type: 'text_area', label: "System Prompt", toolTipInfo: "It is used to guide the model's behavior by providing contextual instructions, enhancing output relevance.", category: "General", field1: "key1", field2: "key2" },
]

export const VoiceParamsFeilds = [
    { key: 'voice_params.max_new_tokens', type: 'dropdown', label: "Max Tokens", toolTipInfo: "It sets the maximum number of tokens generated during text processing, managing model efficiency.", category: "General", field1: "key1", field2: "key2" },
    { key: 'voice_params.chunk_length_s', type: 'dropdown', label: "Chunk Length", toolTipInfo: "It sets the duration(in seconds)of audio chunks processed by the model, and splits longer inputs for processing efficiency.", category: "General", field1: "key1", field2: "key2" },
    { key: 'voice_params.batch_size', type: 'dropdown', label: "Batch Size", toolTipInfo: "This sets the batch size used during inference. It enables parallel computation and faster processing of multiple inputs", category: "General", field1: "key1", field2: "key2" },
]
export const ERROR_MESSAGE = "I'm sorry, but I don't have the information you're looking for. Feel free to ask another question or provide more details, and I'll do my best to assist you!"

export const fileToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = function () {
            resolve(reader.result);
        };

        reader.onerror = function (error) {
            reject(error);
        };
    });
};

export const convertImageUrlToBase64 = (imageUrl: string) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous"; // important for external URLs

        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx: any = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            const dataURL = canvas.toDataURL("image/png"); // PNG base64
            resolve(dataURL);
        };

        img.onerror = () => {
            reject("Failed to load image");
        };

        img.src = imageUrl;
    });
};

export const urlToBase64 = async (imageUrl: string) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
};

export const manipulateBase64Data = async (base64Data: any): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
        const base64Index = base64Data.indexOf('base64');
        if (base64Index !== -1) {
            resolve(base64Data?.slice(base64Index + 7));
        } else {
            resolve(base64Data);
        }
    });
};

export const fileExtChange = (file: any) => {
    if (file.type === "audio/mpeg") {
        return file.name.replace('.mp3', '.txt')
    } else if (file.type === "audio/wav") {
        return file.name.replace('.wav', '.txt')
    } else if (file.type === "audio/vnd.dlna.adts") {
        return file.name.replace('.aac', '.txt')
    } else if (file.type === "audio/ogg") {
        return file.name.replace('.ogg', '.txt')
    }
}

export const audioTypes = ["audio/ogg", "audio/mpeg", "audio/wav", "audio/mp3", "audio/vnd.dlna.adts"];
export const imageTypes = ["image/png", "image/jpeg", "image/webp"];
export const userControlClass = ["groups", "users", "roles", "permission"];
export const dataCollectorClass = ["web-scrapper", "pdf-upload"];
export const product_page_chat_tool_desc = "Use this tool to answer any product-related question except those specifically about the return policy. This tool provides information on attributes like price, color, size,Gender,link,URL,productPage,productDisplayName and product details, ensuring accurate responses for inquiries on product features, availability, and specifications. This is related to the clothing brand."
export const return_policy_tool = "This tool provides comprehensive answers for questions about our return and shipping policies (tracking order and exchange). Key details include eligibility criteria for returns, item condition requirements, and proof of purchase. It outlines the return process, including obtaining a Return Merchandise Authorization (RMA), and options for return shipping costs, which are covered for defective or incorrect items. The refund process explains inspection, refund methods, and conditions for partial refunds. For shipping, it covers processing times, available shipping rates (standard, expedited, next-day), free shipping qualifications, U.S. delivery locations, tracking, handling of undeliverable packages, and potential delays.late delivery."
export const product_recommendation_tool = "This tool provides tailored product recommendations for broader or contextual searches. It handles queries about categories like Fashion & Apparel, Home & Living, Travel Accessories, Electronics, Beauty Products, Home Decor, Mobile, Home Appliances, Automobiles, Beauty & Personal Care, Groceries, Sports & Outdoors, Books & Media, Toys & Games, and Furniture. Use this tool for general searches, gifting suggestions, and lifestyle needs, such as 'best gifts for kids,' 'home decor ideas,' or 'top travel accessories for vacations.' This tool focuses on offering suggestions based on customer preferences and categories rather than specific filtering."
export const product_search = "General product related search. It will have information related to all laptop and product from different brands like Apple, Samsung, Sony, LG, HP, Dell, Lenovo, Realme, MSI etc.";
export const other_tool = "General sales related information. Month wise, yearly, quarterly and day wise sales and revenue information. It also contain the product discount details. Highest sell or most sell product.";
export const faq_tool = "Use it to find the information related to product installation, product manual or general frequently asked questions.";
export const login_tool = "My personal information. You have order and ticket information available in the .If any question asked related to my order details /purchase details or ticket information/details search in the provided information for me.When asked about personal information, provide data from the context. Return and replacement details available."
const base64 = "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"

export const downloadBase64File = () => {
    // Decode the Base64 string
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Create a Blob from the byte array
    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Create a download link
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = "Sample_Schema_Mapping.xlsx";

    // Append the link to the body
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
};

export const downloadBase64FileO = (base64: string) => {
    // Decode the Base64 string
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Create a Blob from the byte array
    const blob = new Blob([byteArray], { type: 'text/csv' });

    // Create a download link
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = "User_Chat_History_Report.csv";

    // Append the link to the body
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
};

export const imageToBase64 = async (url: string, setBase64: any) => {
    try {
        const response = await axios.get(url, { responseType: 'blob' });
        const blob = response.data;

        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64String = reader.result;
            setBase64(base64String);
        };
    } catch (error) {
        console.error('Error converting image to base64:', error);
    }
};

export const handleClearTag = (tag: string, currentTagList: string[], setCurrentTagList: React.Dispatch<React.SetStateAction<string[]>>) => {
    setCurrentTagList(currentTagList.filter(t1 => t1 !== tag))
}

export const handleTagList = (tagValue: string, tagList: string[], setTagList: React.Dispatch<React.SetStateAction<string[]>>, setTagValue: React.Dispatch<React.SetStateAction<string>>) => {
    if (tagValue.trim() !== "") {
        setTagList([...tagList, tagValue.trim().toLowerCase()])
        setTagValue("");
    } else {
        setTagValue("");
        toast.error("Tags cannot be empty. Please add a valid tag", {
            style: {
                backgroundColor: '#F1F1F1', // Grey background
            }
        })
    }
}

export const findParentKeyIndex = (data: any, id: string | null) => {
    const keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const array = data[key];
        for (let j = 0; j < array.length; j++) {
            const item = array[j];
            if (
                item._id === id ||
                item.conversation_id === id ||
                item.input_image_id === id ||
                item.output_image_id.includes(id)
            ) {
                return i;
            }
        }
    }
    return null;
};
export const findConversationId = (data: any, conversationId: string | null) => {
    return Object.keys(data).some((key) => {
        return data[key].some((item: any) => item.conversation_id === conversationId);
    });
};
export const capitalizeFirstLetter = (str: string) => {
    if (!str) return ""; // Check if the string is empty
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const tempBotObj = {
    "_id": "675ad9abc50591bfc9904a64",
    "client_env": "ron_stage",
    "bot_name": "frida",
    "industry": "retail",
    "organization_info": {
        "organization_name": "ZB Financial Holdings",
        "organization_url": "https://www.zb.co.zw/"
    },
    "bot_config": {
        "bot_name": "Welcome to ShopMate",
        "tagline": "Intelligent self-service solutions",
        "initial_message": "Hi, I am your personal shopping assistant, just like ones you have in store!",
        "bot_logo": "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",
        "bot_logo_name": "BG.png",
        "avatar_logo": "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",
        "avatar_logo_name": "BGTRANSPARENT.png",
        "header_colour": "#ffffff",
        "question_background_colour": "#f4f4f4",
        "answer_background_colour": "#5627d9",
        "font_size": 14
    },
    "bot_actions": [
        {
            "action": "login_tool",
            "prompt": "My personal information. You have order and ticket information available in the .If any question asked related to my order details purchase details or ticket sinformation/details search in the provided information for me. When asked about personal information, provide data from the context. Return and replacement details available.s",
            "tables": [
                "ron_order",
                "ron_tickets"
            ],
            "database_name": "ron_retail_client_exp",
            "dialect_database": "postgresql",
            "host": "43.242.38.39",
            "port": 5434,
            "user_name": "keycloak",
            "password": "passw0rd",
        },
        {
            "action": "product_search",
            "prompt": "This is my product related search.Review of the product and rating. It will have information related to all Sofas ,Coffee Tables,Dining Storage,Kitchen,Wall Art and Furniture.Different product specification like dimension,width,height,depth,color,price,average_rating and number_of_rating.",
            "tables": [
                "ashley_product_sample_data"
            ],
            "database_name": "ron_retail_client_exp",
            "dialect_database": "mysql",
            "host": "43.242.38.39",
            "port": 3306,
            "user_name": "admin",
            "password": "Admin@#$123",
            "product_recommendation_tool": "This tool provides tailored product recommendations for broader or contextual searches. It handles queries about categories like Fashion & Apparel, Home & Living, Travel Accessories, Electronics, Beauty Products, Home Decor, Mobile, Home Appliances, Automobiles, Beauty & Personal Care, Groceries, Sports & Outdoors, Books & Media, Toys & Games, and Furniture. Use this tool for general searches, gifting suggestions, and lifestyle needs, such as 'best gifts for kids,' 'home decor ideas,' or 'top travel accessories for vacations.' This tool focuses on offering suggestions based on customer preferences and categories rather than specific filtering.",
            "feature_column_list_input": ["productid,productname,imagelink,price,productdetails,category,subcategory,brand,color,gender,size"],
            "feature_column_list_output": ["productid,productname,imagelink,price,productdetails,category,subcategory,brand,rating,no_of_rating,no_of_reviews,color,gender,size"],
            "top_n": 6,
            "acceptance_threshold": 0.75
        },
        {
            "action": "other_tool",
            "prompt": "General sales related information. Month wise, yearly, quarterly and day wise sales and revenue information. It also contain the product discount details. Highest sell or most sell product.",
            "tables": [
                "ron_sales",
                "dimproduct",
                "dimproductcategory",
                "dimstore",
                "dimproductsubcategory"
            ],
            "database_name": "ron_retail_client_exp",
            "dialect_database": "postgresql",
            "host": "43.242.38.39",
            "port": 5434,
            "user_name": "keycloak",
            "password": "passw0rd"
        },
        {
            "action": "faq_tool",
            "prompt": "Use it to find the information related to product installation, product manual or general frequently asked questions.",
            "tables": null,
            "database_name": null,
            "dialect_database": null,
            "host": null,
            "port": null,
            "user_name": null,
            "password": null
        }
    ],
    "csv_file_name": "Sample_Schema_Mapping (2).xlsx",
    "csv_master_data": "UEsDBBRkZ6DTPh",
    "personalities": ["sincerity", "excitement"],
    "traits": ["kindness", "friendly"],
    "brand_guide_file_name": "brandGuidelineName",
    "social_media_file_name": "socialMediaPostName",
    "brand_guide_file": "data.brand_guide_file",
    "social_media_file": "data.social_media_file",
    "brand_personality_update": false,
    "is_csv_updated": false,
    "upload_policy_csv_file": "data.social_media_file",
    "upload_policy_file_name": "",
    // "upload_policy_file_name": "test.pdf",
    "created_by": "maniratnam.mudaliar@rysun.com",
    "version": 106,
    "created_at": "2024-12-12T18:10:11.150000"
}

export const yesSynonyms = ["yes", "yep", "yup", "yeah", "sure", "uh-huh", "definitely", "totally", "you bet", "without a doubt", "aye", "fo sho", "yepper", "alright", "okay", "fine", "agrred", "absolutely", "certainly", "indeed", "of course", "affirmative"]
export const noSynonyms = ["no", "not", "certainly not", "by no means", "not at all", "negative", "i'am afraid not", "nope", "nah", "no way", "uh-uh", "never", "don't", "nah-ah", "nada"]
export const formateDate = (date: string | Date) => {
    const inputDate = new Date(date)
    const year = inputDate.getFullYear()
    const month = String(inputDate.getMonth() + 1).padStart(2, "0")
    const day = String(inputDate.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
}

export const tempArray = [
    {
        "Payroll_Name": "Duhe, Jude M",
        "Legal_First_Name": "Gas Chromatography Manager",
        "Legal_Last_Name": "Jude",
        "Job_Title": "Duhe",
        "Reports_to_Legal_Name": "Loor, Luis",
        "Work_Email": "jude.duhe@amspecgroup.com",
        "Hierarchy_Level": "1",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Guitrau, Ross Michael",
        "Legal_First_Name": "Area Lab Manager Inland Waterways",
        "Legal_Last_Name": "Ross",
        "Job_Title": "Guitrau",
        "Reports_to_Legal_Name": "Loor, Luis",
        "Work_Email": "Ross.Guitrau@amspecgroup.com",
        "Hierarchy_Level": "1",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Jackson, Lorna A",
        "Legal_First_Name": "Area Manager, US Inland Waterways - MW",
        "Legal_Last_Name": "Lorna",
        "Job_Title": "Jackson",
        "Reports_to_Legal_Name": "Loor, Luis",
        "Work_Email": "lorna.jackson@amspecgroup.com",
        "Hierarchy_Level": "1",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Loor, Luis",
        "Legal_First_Name": "Area Lab Manager- US IW/MW",
        "Legal_Last_Name": "Luis",
        "Job_Title": "Loor",
        "Reports_to_Legal_Name": "Bailey, Michael",
        "Work_Email": "luis.loor@amspecgroup.com",
        "Hierarchy_Level": "1",
        "Relationship_Type": "Manager"
    },
    {
        "Payroll_Name": "Mauch, Carol",
        "Legal_First_Name": "Regional Ashpalt Manager",
        "Legal_Last_Name": "Carol",
        "Job_Title": "Mauch",
        "Reports_to_Legal_Name": "Loor, Luis",
        "Work_Email": "Carol.Mauch@amspecgroup.com",
        "Hierarchy_Level": "1",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Peralta, Ryan",
        "Legal_First_Name": "Lab Manager",
        "Legal_Last_Name": "Ryan",
        "Job_Title": "Peralta",
        "Reports_to_Legal_Name": "Loor, Luis",
        "Work_Email": "ryan.peralta@amspecgroup.com",
        "Hierarchy_Level": "1",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Addison, James T",
        "Legal_First_Name": "QA Coordinator",
        "Legal_Last_Name": "James",
        "Job_Title": "Addison",
        "Reports_to_Legal_Name": "Mauch, Carol",
        "Work_Email": "james.addison@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Alvarez, Karen J",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Karen",
        "Job_Title": "Alvarez",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Karen.Alvarez@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Anderson, Gabrielle F",
        "Legal_First_Name": "Lab Administrator ",
        "Legal_Last_Name": "Gabrielle",
        "Job_Title": "Anderson",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "gabrielle.anderson@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Angellotti, Attilio J",
        "Legal_First_Name": "Lab Shift Supervisor",
        "Legal_Last_Name": "Attilio",
        "Job_Title": "Angellotti",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Attilio.Angellotti@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Arguelles, Alben A",
        "Legal_First_Name": "Assistant Lab Manager 1",
        "Legal_Last_Name": "Alben",
        "Job_Title": "Arguelles",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Alben.Arguelles@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Arguelles, Kylie A",
        "Legal_First_Name": "Lab Administrator ",
        "Legal_Last_Name": "Kylie",
        "Job_Title": "Arguelles",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Kylie.Arguelles@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Bailey, Dara C",
        "Legal_First_Name": "Lab Supervisor",
        "Legal_Last_Name": "Dara",
        "Job_Title": "Bailey",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "dara.bailey@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Bailey, Michael",
        "Legal_First_Name": "VP West Hemisphere Laboratories",
        "Legal_Last_Name": "Michael",
        "Job_Title": "Bailey",
        "Reports_to_Legal_Name": "Vella, Malcolm",
        "Work_Email": "Michael.Bailey@AmspecGroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Manager"
    },
    {
        "Payroll_Name": "Blade, Kijauna A",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Kijauna",
        "Job_Title": "Blade",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Kijauna.Blade@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Bradley, Angela M",
        "Legal_First_Name": "Asphalt Lab Technician",
        "Legal_Last_Name": "Angela",
        "Job_Title": "Bradley",
        "Reports_to_Legal_Name": "Mauch, Carol",
        "Work_Email": "angela.bradley@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Camp, Jonathan Dwayne",
        "Legal_First_Name": "Engine Supervisor",
        "Legal_Last_Name": "Jonathan",
        "Job_Title": "Camp",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Jonathan.Camp@Amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Crisostomo, Ara Katrina L",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Ara Katrina",
        "Job_Title": "Crisostomo",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "ara.crisostomo@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Dalton, Christopher D",
        "Legal_First_Name": "Asphalt Lab Technician",
        "Legal_Last_Name": "Christopher",
        "Job_Title": "Dalton",
        "Reports_to_Legal_Name": "Mauch, Carol",
        "Work_Email": "Christopher.Dalton@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Dalton, Joseph A",
        "Legal_First_Name": "Asphalt Lab Manager",
        "Legal_Last_Name": "Joseph",
        "Job_Title": "Dalton",
        "Reports_to_Legal_Name": "Mauch, Carol",
        "Work_Email": "joe.dalton@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Devenny, Richard",
        "Legal_First_Name": "Assistant Lab Manager 1",
        "Legal_Last_Name": "Richard",
        "Job_Title": "Devenny",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Ricky.Devenny@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Eagan, Cody S",
        "Legal_First_Name": "Lab Retain 2",
        "Legal_Last_Name": "Cody",
        "Job_Title": "Eagan",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "cody.eagan@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Emanuel, Paul W",
        "Legal_First_Name": "Lab Manager",
        "Legal_Last_Name": "Paul",
        "Job_Title": "Emanuel",
        "Reports_to_Legal_Name": "Jackson, Lorna",
        "Work_Email": "Paul.Emanuel@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Feliciano, Nadia D",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Nadia",
        "Job_Title": "Feliciano",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "nadia.feliciano@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Fonseca, Kevin A",
        "Legal_First_Name": "Lab Retain 2",
        "Legal_Last_Name": "Kevin",
        "Job_Title": "Fonseca",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "kevin.fonseca@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Gudiel, Diego A",
        "Legal_First_Name": "Lab Retain 2",
        "Legal_Last_Name": "Diego",
        "Job_Title": "Gudiel",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "diego.gudiel@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Jaouani, Jihed",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Jihed",
        "Job_Title": "Jaouani",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Jihed.Jaouani@AmSpecGroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Kaiden, Elizabeth A",
        "Legal_First_Name": "Asphalt Lab Technician",
        "Legal_Last_Name": "Elizabeth",
        "Job_Title": "Kaiden",
        "Reports_to_Legal_Name": "Mauch, Carol",
        "Work_Email": "elizabeth.kaiden@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Kinzer, David S",
        "Legal_First_Name": "Asphalt Lab Manager",
        "Legal_Last_Name": "David",
        "Job_Title": "Kinzer",
        "Reports_to_Legal_Name": "Mauch, Carol",
        "Work_Email": "david.kinzer@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Lirette, Christopher D",
        "Legal_First_Name": "Laboratory Supervisor",
        "Legal_Last_Name": "Christopher",
        "Job_Title": "Lirette",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "christopher.lirette@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Luccioni, Wanda P",
        "Legal_First_Name": "QA/QC Coordinator",
        "Legal_Last_Name": "Wanda",
        "Job_Title": "Luccioni",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "wanda.luccioni@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Madrigal, Jeremy E",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Jeremy",
        "Job_Title": "Madrigal",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "jeremy.madrigal@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Madrigal, Nicholas E",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Nicholas",
        "Job_Title": "Madrigal",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "nicholas.madrigal@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Marechal, Nicholas W",
        "Legal_First_Name": "QA/QC Supervisor",
        "Legal_Last_Name": "Nicholas",
        "Job_Title": "Marechal",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Nicholas.Marechal@AmSpecGroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Melara, Christian G",
        "Legal_First_Name": "Lab Shift Supervisor",
        "Legal_Last_Name": "Christian",
        "Job_Title": "Melara",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Christian.Melara@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Mollere, Michael J",
        "Legal_First_Name": "Lab Retain 2",
        "Legal_Last_Name": "Michael",
        "Job_Title": "Mollere",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Michael.Mollere@AmSpecGroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Norton, Molly C",
        "Legal_First_Name": "Asphalt Lab Technician",
        "Legal_Last_Name": "Molly",
        "Job_Title": "Norton",
        "Reports_to_Legal_Name": "Mauch, Carol",
        "Work_Email": "molly.norton@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Peth, Randy M",
        "Legal_First_Name": "Asphalt Lab Supervisor",
        "Legal_Last_Name": "Randy",
        "Job_Title": "Peth",
        "Reports_to_Legal_Name": "Mauch, Carol",
        "Work_Email": "randy.peth@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Plaisance Jr, Gregory A",
        "Legal_First_Name": "Laboratory Supervisor",
        "Legal_Last_Name": "Gregory",
        "Job_Title": "Plaisance Jr",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Gregory.Plaisance@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Poirier, Brian J",
        "Legal_First_Name": "Lab Supervisor",
        "Legal_Last_Name": "Brian",
        "Job_Title": "Poirier",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Brian.Poirier@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Rivera, Anthony S",
        "Legal_First_Name": "Lab Retain 2",
        "Legal_Last_Name": "Anthony",
        "Job_Title": "Rivera",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Anthony.Rivera@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Sears, Nicholas D",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Nicholas",
        "Job_Title": "Sears",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Nicholas.Sears@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Sears, Terrell",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Terrell",
        "Job_Title": "Sears",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "terrell.sears@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Seaward, Don P",
        "Legal_First_Name": "Asphalt Lab Technician",
        "Legal_Last_Name": "Don",
        "Job_Title": "Seaward",
        "Reports_to_Legal_Name": "Mauch, Carol",
        "Work_Email": "Don.Seaward@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Smith, Byron B",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Byron",
        "Job_Title": "Smith",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Byron.Smith@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Spencer, Brittany A",
        "Legal_First_Name": "Asphalt Lab Technician",
        "Legal_Last_Name": "Brittany",
        "Job_Title": "Spencer",
        "Reports_to_Legal_Name": "Mauch, Carol",
        "Work_Email": "Brittany.spencer@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Tabora, Jennifer",
        "Legal_First_Name": "Lab Administrator ",
        "Legal_Last_Name": "Jennifer",
        "Job_Title": "Tabora",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "jennifer.tabora@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Thomas, Lacy O",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Lacy",
        "Job_Title": "Thomas",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "lacy.thomas@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Tran, Long T",
        "Legal_First_Name": "Regional Gas Chromatography Supervisor",
        "Legal_Last_Name": "Long",
        "Job_Title": "Tran",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Long.Tran@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Vera, Miguel M",
        "Legal_First_Name": "Lab Technician2",
        "Legal_Last_Name": "Miguel",
        "Job_Title": "Vera",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Miguel.Vera@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Vu, Khanh J",
        "Legal_First_Name": "Asphalt Lab Technician",
        "Legal_Last_Name": "Khanh",
        "Job_Title": "Vu",
        "Reports_to_Legal_Name": "Mauch, Carol",
        "Work_Email": "Khanh.Vu@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Walker, Thomas A",
        "Legal_First_Name": "Retain Manager1",
        "Legal_Last_Name": "Thomas",
        "Job_Title": "Walker",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "thomas.walker@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    },
    {
        "Payroll_Name": "Zar, Derek K",
        "Legal_First_Name": "Engine Supervisor",
        "Legal_Last_Name": "Derek",
        "Job_Title": "Zar",
        "Reports_to_Legal_Name": "Peralta, Ryan",
        "Work_Email": "Derek.Zar@amspecgroup.com",
        "Hierarchy_Level": "2",
        "Relationship_Type": "Reportee"
    }
]

export const butterPieObj = {
    "niche_topics": [],
    "niche_topics_other": '',
    "unique_expertise": "",
    "content_focus": '',
    "content_focus_other": "",
    "creator_why": [],
    "career_goals": '',
    "success_definition": [],
    "success_definition_other": '',
    "creation_skills": [],
    "creation_skills_other": '',
    "comfort_level": [],
    "past_experience": "",
    "platform_preference": [],
    "content_format": "",
    "multichannel_strategy": "",
    "time_commitment": 1,
    "budget": 100,
    "learning_willingness": "",
    "monetization_timing": "",
    "revenue_streams": [],
    "existing_business": "",
    "natural_talents": "",
    "struggle_areas": "",
    "obstacles": "",
    "ai_tools_openness": "",
    "workflow_automation": "",
    "seo_algorithms": ""
}

export const getRadioOptions = (questionId: string) => {
    switch (questionId) {
        case 'content_focus':
            return [
                { value: 'education', label: 'Education' },
                { value: 'entertainment', label: 'Entertainment' },
                { value: 'storytelling', label: 'Storytelling' },
                { value: 'community', label: 'Community Building' },
                { value: 'other', label: 'Other' }
            ];
        case 'career_goals':
            return [
                { value: 'full-time', label: 'Full-Time Career' },
                { value: 'side-project', label: 'Side Project' },
                { value: 'undecided', label: 'Undecided' }
            ];
        case 'comfort_level':
            return [
                { value: 'yes', label: 'Very Comfortable' },
                { value: 'somewhat', label: 'Somewhat Comfortable' },
                { value: 'no', label: 'Not Comfortable' }
            ];
        case 'content_format':
            return [
                { value: 'short form', label: 'Short-Form Content' },
                { value: 'long form', label: 'Long-Form Content' },
                { value: 'both', label: 'Both' }
            ];
        case 'monetization_timing':
            return [
                { value: 'growth first', label: 'Focus on Growth First' },
                { value: 'early monetization', label: 'Monetize Early' },
                { value: 'balanced', label: 'Balanced Approach' }
            ];
        case 'multichannel_strategy':
            return [
                { value: 'Multi-channel', label: 'Multi-Channel Approach' },
                { value: 'single platform', label: 'Focus on One Platform' }
            ];
        case 'ai_tools_openness':
            return [
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' },
                { value: 'not sure', label: 'Not Sure' },
            ];
        case 'seo_algorithms':
            return [
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' },
            ];
        case 'workflow_automation':
            return [
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' },
            ];
        case 'existing_business':
            return [
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' },
            ];
        case 'learning_willingness':
            return [
                { value: 'newtools', label: 'New Tools' },
                { value: 'hirehelp', label: 'Hire Help' },
                { value: 'none', label: 'None of the above' },
            ];
        default:
            return [
                { value: 'yes', label: 'Yes' },
                { value: 'no', label: 'No' },
                { value: 'maybe', label: 'Maybe' }
            ];
    }
};

export const getCheckboxOptions = (questionId: string) => {
    switch (questionId) {
        case 'niche_topics':
            return [
                { value: 'tech', label: 'Tech' },
                { value: 'finance', label: 'Finance' },
                { value: 'fashion', label: 'Fashion' },
                { value: 'products', label: 'Products' },
                { value: 'gaming', label: 'Gaming' },
                { value: 'other', label: 'Other' }
            ];
        case 'creator_why':
            return [
                { value: 'passion', label: 'Passion' },
                { value: 'income', label: 'Income' },
                { value: 'brand building', label: 'Brand Building' },
                { value: 'creative outlet', label: 'Creative Outlet' }
            ];
        case 'success_definition':
            return [
                { value: 'followers', label: 'Followers' },
                { value: 'engagement', label: 'Engagement' },
                { value: 'revenue', label: 'Revenue' },
                { value: 'impact', label: 'Impact' },
                { value: 'other', label: 'Other' }
            ];
        case 'creation_skills':
            return [
                { value: 'video editing', label: 'Video Editing' },
                { value: 'writing', label: 'Writing' },
                { value: 'design', label: 'Design' },
                { value: 'other', label: 'Other' }
            ];
        case 'platform_preference':
            return [
                { value: 'Tiktok', label: 'Tiktok' },
                { value: 'Youtube', label: 'Youtube' },
                { value: 'Instagram', label: 'Instagram' },
                { value: 'Twitter', label: 'Twitter/X' },
                { value: 'LinkedIn', label: 'LinkedIn' },
            ];
        case 'revenue_streams':
            return [
                { value: 'brand deals', label: 'Brand Deals & Sponsorships' },
                { value: 'ad revenue', label: 'Ad Revenue' },
                { value: 'memberships', label: 'Memberships & Subscriptions' },
                { value: 'products', label: 'Digital/Physical Products' }
            ];
        case 'comfort_level':
            return [
                { value: 'camera', label: 'Camera' },
                { value: 'podcasting', label: 'Podcasting' },
                { value: 'writing', label: 'Writing' }
            ];
        default:
            return [
                { value: 'option1', label: 'Option 1' },
                { value: 'option2', label: 'Option 2' },
                { value: 'option3', label: 'Option 3' }
            ];
    }
};

export const findStepWhichAreIncomplete = (name: string) => {
    if (['niche_topics', 'unique_expertise', 'content_focus'].includes(name)) {
        return 1
    } else if (['creator_why', 'career_goals', 'success_definition'].includes(name)) {
        return 2
    } else if (['creation_skills', 'comfort_level', 'past_experience'].includes(name)) {
        return 3
    } else if (['platform_preference', 'content_format', 'multichannel_strategy'].includes(name)) {
        return 4
    } else if (['time_commitment', 'budget', 'learning_willingness'].includes(name)) {
        return 5
    } else if (['monetization_timing', 'revenue_streams', 'existing_business'].includes(name)) {
        return 6
    } else if (['natural_talents', 'struggle_areas', 'obstacles'].includes(name)) {
        return 7
    } else if (['ai_tools_openness', 'workflow_automation', 'seo_algorithms'].includes(name)) {
        return 8
    }
}

export const categoriesOfButterPie = [
    'Content Strategy & Branding',
    'Content Production & Editing',
    'Audience Growth & Engagement',
    'Monetization & Business Strategy',
    'Marketing & SEO',
    'Legal & Ethical Considerations',
    'Mindset & Productivity',
    'Networking & Collaboration',
]

export const downloadPdfFromBase64 = (base64Data: string, fileName: string) => {
    // Decode base64 string to binary string
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    // Convert byte numbers to a typed array
    const byteArray = new Uint8Array(byteNumbers);
    // Create a blob from the byte array
    const blob = new Blob([byteArray], { type: "application/pdf" });
    // Create a URL for the Blob
    const blobUrl = URL.createObjectURL(blob);

    // Create a link element, set its download attribute, and trigger click
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    link.click();

    // Optionally revoke the URL to free memory after some delay
    setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
};
